export default __webpack_public_path__ + "static/media/vault.14c40c37.svg";